import React, { useState } from 'react'
import mark from '../Images/brand-mark.svg'
import { FiSearch, FiUser } from 'react-icons/fi'
import LangSwitch from './LangSwitch';
import { useTranslation } from 'react-i18next';
import { FiBookmark } from 'react-icons/fi';
import { HiMenu } from 'react-icons/hi';
import { api, isLoggedIn, clearAuth } from '../api';
import { useNavigate, NavLink, Link } from 'react-router-dom';
import { loginUrl } from '../authNext';

export default function Navbar() {
  const [postOpen, setPostOpen] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const loggedIn = isLoggedIn();

  const handleLogout = async () => {
    await api.logout(); // serverda refresh tokenni bekor qilish
    clearAuth();
    navigate('/login');
  };

  return (
    <div className='box'>
      <div className='navbar'>
        <div className='nav_left'>
          <Link to='/' className='logo-link brand' aria-label={t('Ijarachi — bosh sahifa')}>
            <img className='brand-mark' src={mark} alt='' width='52' height='40' />
            <span className='brand-text'><b><em>My</em> Ijarachi</b><small>{t('Bir tom ostida — birga')}</small></span>
          </Link>
          <button type='button' aria-label='Menu' onClick={() => setMenuOpen(!menuOpen)} className='media_menu'><HiMenu /></button>
          <div className='navbar-left-list'>
            <ul className={menuOpen ? "open" : "close"}>
              {/* Asosiy yo'llar; «Biz haqimizda» — footerda (bosh sahifa — logotip) */}
              <li><NavLink to='/allrentadvertising' className='nav-link' onClick={() => setMenuOpen(false)}>{t("nav_rent")}</NavLink></li>
              <li><NavLink to='/allpatneradvertising' className='nav-link' onClick={() => setMenuOpen(false)}>{t("nav_partner")}</NavLink></li>
              <li><NavLink to='/wanted' className='nav-link' onClick={() => setMenuOpen(false)}>{t("nav_wanted")}</NavLink></li>
              {!loggedIn && <li className='m-only'><NavLink to='/login' className='nav-link' onClick={() => setMenuOpen(false)}>{t('Kirish')}</NavLink></li>}
              {/* Telefonda: navbarga sig'magan tugmalar shu menyuda */}
              {loggedIn && <li className='m-only'><NavLink to='/profile/saved' className='nav-link' onClick={() => setMenuOpen(false)}>{t('Saqlanganlar')}</NavLink></li>}
              {loggedIn && <li className='m-only'><button type='button' className='nav-link m-logout' onClick={() => { setMenuOpen(false); handleLogout(); }}>{t('Chiqish')}</button></li>}
            </ul>
          </div>
        </div>
        <div className='nav_right'>
          <ul>
            <li><button type="button" aria-label="Search" className="nav-icon-btn" onClick={() => navigate('/allrentadvertising')}><FiSearch /></button></li>
            <li><button type="button" aria-label="Saved" className="nav-icon-btn" onClick={() => navigate(loggedIn ? '/profile/saved' : '/login')}><FiBookmark /></button></li>
            <li className='nav-post'>
              <button type='button' className='nav-post-btn' aria-haspopup='menu' aria-expanded={postOpen}
                onClick={() => setPostOpen(o => !o)}>{t("+ E'lon joylash")}</button>
              {postOpen && (
                <div className='nav-post-menu' role='menu' onMouseLeave={() => setPostOpen(false)}>
                  {/* E'lon formasi login'siz ochiladi — login faqat «Joylash» bosilganda so'raladi */}
                  <button type='button' role='menuitem' onClick={() => { setPostOpen(false); navigate(loggedIn ? '/profile/elonlar?tur=rent' : '/elon-joylash?tur=rent'); }}>
                    <b>{t('Uyni ijaraga berish')}</b><span>{t('Kvartira yoki hovli')}</span></button>
                  <button type='button' role='menuitem' onClick={() => { setPostOpen(false); navigate(loggedIn ? '/profile/elonlar?tur=sherik' : '/elon-joylash?tur=sherik'); }}>
                    <b>{t('Sherik qidirish')}</b><span>{t("Bo'sh xonaga xonadosh")}</span></button>
                  <button type='button' role='menuitem' onClick={() => { setPostOpen(false); navigate(loggedIn ? '/profile/wanted?new=1' : loginUrl('/profile/wanted?new=1')); }}>
                    <b>{t('Uy kerak')}</b><span>{t('Talabingizni yozing, egalar taklif qiladi')}</span></button>
                </div>
              )}
            </li>
            {loggedIn ? (
              <>
                <li><a href='/profile/userinfo' aria-label='Profile'><FiUser /></a></li>
                <li>
                  <button type='button' className='nav-logout' onClick={handleLogout}>{t('Chiqish')}</button>
                </li>
              </>
            ) : (
              <li><a href='/login' aria-label='Login'><FiUser /></a></li>
            )}
            <li><LangSwitch /></li>
          </ul>
        </div>
      </div>
    </div>
  )
}
